import React from "react";
import { useBooleanState } from "src/hooks/utils";
import Templates2RolesModal from "./index";

const useTemplates2RolesModal = (templateId: number) => {
  const [isOpen, toggleModal] = useBooleanState(false);

  const modal = (
    <Templates2RolesModal
      isOpen={isOpen}
      templateId={templateId}
      toggleModal={toggleModal}
    />
  );

  return {
    toggleTemplates2RolesModal: toggleModal,
    templates2RolesModal: modal,
  };
};

export default useTemplates2RolesModal;
